import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import EventsScreen from './events';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';
import Alcoholic from './alcoholic';
import Drinks from './drinks';
import LunchSpecial from './lunchspecial';
import translateMenu from '../../helpers/translateMenu';
import Today from './today';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [dataDish, setDataDish] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [desserts, setdesserts] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showLunchSpecial, setShowLunchSpecial] = useState(false);
    const [Beverages, setBeverages] = useState(false);
    const [showToday, setshowToday] = useState(false);

   

    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };




         const {
           goHomeInit
         } = useSelector((state) => state.initLoad);
        
    
    
     const Item = ({ item }) => {
        const isSelected = dishs && dishs.id === item.id;

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: 55,
                    position: 'relative',
                    cursor: 'pointer',
                    backgroundImage: `url(${require('./assets/BOTON1.png')})`,
                    backgroundPosition: 'center',
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    opacity: isSelected ? 1 : 0.95,
                    marginBottom: 10,
                }}
                onClick={() => {
                    if (item.id === 921) {
                        setshowToday(true);
                    } else {
                        setShowListProduct(true);
                        setdishs(item);
                    }
                }}
            >
                <p
                    style={{
                        color: '#000',
                        fontSize: 20,
                        
                        letterSpacing: 1,
                        textAlign: 'center',
                        fontFamily: 'Avilock',
                        textTransform: 'uppercase',
                        margin: 0,
                        maxWidth: '80%',
                    }}
                >
                   {langEng ? 
                                    `${item.name.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    item.language, 
                                    item.name, 
                                    'name'
                                )}`
                        }
                </p>
            </div>
        );
     };
    
        
    

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 725) {
                setdesserts(item);
            }
            if (item.id === 925) {
                setBeverages(item);
            }


            
        });
    }, [menus]);


    const GoBeverages = () => {
        setShowListProduct(true);
        setdishs(Beverages);
    }


    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
          
          
           setShowLunchSpecial(false)
          
            setshowCategories(false)
            setShowDetailProduct(false)
            setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


      useEffect(() => {
     
                setShowListProduct(false);
            setShowSpecials(false)
          
           
           setShowLunchSpecial(false)
          
            setshowCategories(false)
          setShowDetailProduct(false)
           setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)
         }, [goHomeInit]);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

        
    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
                setShowListProduct(true)
                setdishs(Beverages)
        }} showBack={false} showCocktails={ GoBeverages} showEvents={ setShowEvents} showImageTop={true} setShowSpecials={setShowSpecials}>
                <div>
                    

                    <div style={{ width: '100%', position: 'relative', zIndex: 900, marginTop: -20, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{
                            position: 'absolute',
                            left:22,top: 27,
                            padding: 5, display: "flex", gap: 10, borderRadius: 14
                        }}>
                            <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 40,
                            height: 40,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 10,
                            marginBottom: 10
                                
                            
                            
                            
                        }}
                        src={require('./assets/instagram.png')}
                            />
                            <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 40,
                            height: 40,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 10,
                            marginBottom: 10
                                
                            
                            
                            
                        }}
                        src={require('./assets/facebook.png')}
                        />
                        </div>
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 300,
                            height: 100,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 10,
                            marginBottom: 30
                                
                            
                            
                            
                        }}
                        src={require('./assets/logo.png')}
                        />

                        
                       
                    </div>

                     <div
                    onClick={() => {
                       // setShowListProduct(true)
                        //setdishs(desserts)
                        //  setShowDetailProduct(true)
                 //   setDataDish({ dish: tomahawk, alldish: steak, currentDish: tomahawk })
               }}
                style={{
                    width: '100%',
                    alignItems: 'center',
                
                    boxSizing: 'border-box',
                   
                    }}>
                    <video
                        loop autoPlay={true} muted 
                        onContextMenu={(e) => e.preventDefault()}
                        //src={require('./assets/bannerinferior.png')}
                        src={require('./assets/banner2.mp4')}
                            style={{
                        marginTop: 10,
                        width: '95%',
                        height: 180,
                        objectFit: 'contain',
                        borderRadius: 15,
                         pointerEvents: 'none',
                        
                    }}
                    />
                  
            </div>
                    
                    <div style={{
                     display: 'flex', width: '100%',
                        position: 'relative', zIndex: 100, paddingInline: 20,
                        boxSizing: 'border-box',
                        gap: 10,
                       
                    }}>
                       
                        
                    <div style={{ width: '70%', marginTop: 10}}>
                            <div style={{ display: 'flex', gap: 1 }}>
                                <img
                           
                            src={require('./assets/BANNERVERTICAL.png')}
                            loop autoPlay={true} muted 
                            style={{
                               
                                width: '100%',
                                height: 245,
                                objectFit: 'contain',
                                borderRadius: 14,
                                alignSelf: 'self-start',
                               
                            }}
                            />
                            <img
                           
                            src={require('./assets/banner33.png')}
                            loop autoPlay={true} muted 
                            style={{
                               
                                width: '100%',
                                height: 245,
                                objectFit: 'contain',
                                borderRadius: 14,
                                alignSelf: 'self-start',
                               
                            }}
                            />
                            </div>

                            <img
                           
                            src={require('./assets/BANNER4.png')}
                            loop autoPlay={true} muted 
                            style={{
                               
                                width: '100%',
                                height: 200,
                                objectFit: 'contain',
                                borderRadius: 14,
                                alignSelf: 'self-start',
                                marginTop: 40,
                               
                            }}
                            />
                            
                           

                    </div>

                    <div style={{ width: '30%', marginTop: 5 }} >
                          
                        <div
                            style={{
                                display: 'grid',
                                height: 515,
                                overflowY: 'auto',
                                paddingRight: 0,
                                boxSizing: 'border-box',
                                marginTop: 5,
                            }}
                        >
                            
                                {menus.map((item, key) => {
                               if (![768, 726, 769, 770, 983].includes(item.id)) {
                                    return <Item item={item} key={key} />;
                                }
                            })}
                           
                        </div>
                    </div>

                    
                </div>
               
            </div>

           

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
                 {showToday && <Today setShowListProduct={setshowToday} />}

                {showLunchSpecial && <LunchSpecial setShowHappy={setShowLunchSpecial} />}
                
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showDrinks && <Drinks setShowHappy={setShowDrinks} />}  
                 {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={()=>setShowDetailProduct(false)}
                    setShowDetailProduct={setShowDetailProduct}
                />}
                

            </LayoutContent>
            </div>
    );
}

export default Index;